import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { cn } from '../utils/cn';

export const Modal = ({ isOpen, onClose, title, children, size = 'md', headerActions }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const sizes = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl',
    small: 'max-w-md',
    medium: 'max-w-[600px]', // Pour PaymentModal et autres modals moyennes
    large: 'max-w-4xl',
    fullheight: 'max-w-4xl',
    fullscreen: 'max-w-[900px] w-[80vw]', // Pour les modals avec beaucoup de contenu
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className={cn(
        'relative bg-white rounded-xl shadow-2xl w-full',
        sizes[size],
        (size === 'fullheight' || size === 'fullscreen') && 'h-[90vh] flex flex-col'
      )}>
        {/* Header */}
        {title && (
          <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 flex-shrink-0">
            <h2 className="text-xl font-bold text-gray-900">{title}</h2>
            <div className="flex items-center gap-2">
              {/* Actions personnalisées dans le header */}
              {headerActions}
              <button
                onClick={onClose}
                className="p-1 hover:bg-gray-100 rounded transition-colors"
              >
                <X className="w-5 h-5 text-gray-600" />
              </button>
            </div>
          </div>
        )}

        {/* Content */}
        <div className={cn(
          'p-4 overflow-y-auto',
          (size === 'fullheight' || size === 'fullscreen') ? 'flex-1' : 'max-h-[85vh]'
        )}>
          {children}
        </div>
      </div>
    </div>
  );
};
